import type { ComponentChildren } from 'preact';
import { closePanel } from './store';

interface Props {
  title: string;
  width?: number | string;
  height?: number | string;
  children: ComponentChildren;
  onClose?: () => void;
  className?: string;
  /** Anchor: centred modal or right-docked. */
  dock?: 'center' | 'right' | 'left';
}

/** Standard window chrome: dark panel, serif title with gold rule, close button. */
export function Window({ title, width = 720, height, children, onClose, className = '', dock = 'center' }: Props) {
  const pos =
    dock === 'right'
      ? { right: '1.2vw', top: '8vh' }
      : dock === 'left'
        ? { left: '1.2vw', top: '8vh' }
        : { left: '50%', top: '50%', transform: 'translate(-50%, -50%)' };
  return (
    <div
      class={`panel window ${className}`}
      style={{ position: 'absolute', width, height, maxWidth: 'calc(100vw - 16px)', maxHeight: '86vh', display: 'flex', flexDirection: 'column', ...pos }}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <div class="panel__title">
        {title}
        <button class="panel__close" aria-label="Close" onClick={() => (onClose ? onClose() : closePanel())}>
          ✕
        </button>
      </div>
      <div class="window__body" style={{ padding: '12px 14px', overflow: 'auto', flex: 1 }}>
        {children}
      </div>
    </div>
  );
}
